var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { makeAutoObservable } from "mobx";
import { inject } from "tsyringe";
import { RSet } from "../collections";
import { Now, RDate } from "../core";
import { perRestaurant } from "../di";
import { IOrderingHours, OnlineOrderingSettingsToken, SchedulesAvailableNow, } from "../ordering";
import { PAiWaiter } from "./PAiWaiter";
import { PCart } from "./PCart";
import { PCrossSellingAddToCartBottomSheet } from "./PCrossSellingAddToCartBottomSheet";
import { PCrossSellingBottomSheet } from "./PCrossSellingBottomSheet";
import { PFreeDeliveryWithAddressStickyAlert } from "./PFreeDeliveryWithAddressStickyAlert";
import { PFreeDeliveryWithoutAddressBottomSheet } from "./PFreeDeliveryWithoutAddressBottomSheet";
import { PRestaurant } from "./PRestaurant";
import { PShortForOrderAlert } from "./PShortForOrderAlert";
import { LabelsService } from "../labels";
let PMenuIntegrationContext = class PMenuIntegrationContext {
    constructor(now, labelsService, cart, restaurant, schedulesAvailableNow, orderingHours, onlineOrderingSettings, aiWaiter, freeDeliveryWithoutAddressBottomSheet, freeDeliveryWithAddressStickyAlert, shortForOrderAlert, crossSellingBottomSheet, crossSellingAddToCartBottomSheet) {
        this.now = now;
        this.labelsService = labelsService;
        this.cart = cart;
        this.restaurant = restaurant;
        this.schedulesAvailableNow = schedulesAvailableNow;
        this.orderingHours = orderingHours;
        this.onlineOrderingSettings = onlineOrderingSettings;
        this.aiWaiter = aiWaiter;
        this.freeDeliveryWithoutAddressBottomSheet = freeDeliveryWithoutAddressBottomSheet;
        this.freeDeliveryWithAddressStickyAlert = freeDeliveryWithAddressStickyAlert;
        this.shortForOrderAlert = shortForOrderAlert;
        this.crossSellingBottomSheet = crossSellingBottomSheet;
        this.crossSellingAddToCartBottomSheet = crossSellingAddToCartBottomSheet;
        this.menu = this.restaurant.menu;
        makeAutoObservable(this);
    }
    labels(menuSectionItem) {
        return this.labelsService.menuLabels(menuSectionItem.content.instances);
    }
    findSection(sectionId) {
        return this.menu.sections.rawFind(sectionId);
    }
    findSchedule(scheduleId) {
        return this.menu.findSchedule(scheduleId);
    }
    findPromotion(promotionId) {
        return this.restaurant.promotionTypes.rawFind(promotionId);
    }
    isScheduleAvailableNow(schedule) {
        return this.schedulesAvailableNow.includes(schedule.id);
    }
};
PMenuIntegrationContext = __decorate([
    perRestaurant(),
    __param(0, inject(Now)),
    __param(4, inject(SchedulesAvailableNow)),
    __param(5, inject(IOrderingHours)),
    __param(6, inject(OnlineOrderingSettingsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof RDate !== "undefined" && RDate) === "function" ? _a : Object, typeof (_b = typeof LabelsService !== "undefined" && LabelsService) === "function" ? _b : Object, typeof (_c = typeof PCart !== "undefined" && PCart) === "function" ? _c : Object, typeof (_d = typeof PRestaurant !== "undefined" && PRestaurant) === "function" ? _d : Object, typeof (_e = typeof RSet !== "undefined" && RSet) === "function" ? _e : Object, typeof (_f = typeof IOrderingHours !== "undefined" && IOrderingHours) === "function" ? _f : Object, Object, typeof (_g = typeof PAiWaiter !== "undefined" && PAiWaiter) === "function" ? _g : Object, typeof (_h = typeof PFreeDeliveryWithoutAddressBottomSheet !== "undefined" && PFreeDeliveryWithoutAddressBottomSheet) === "function" ? _h : Object, typeof (_j = typeof PFreeDeliveryWithAddressStickyAlert !== "undefined" && PFreeDeliveryWithAddressStickyAlert) === "function" ? _j : Object, typeof (_k = typeof PShortForOrderAlert !== "undefined" && PShortForOrderAlert) === "function" ? _k : Object, typeof (_l = typeof PCrossSellingBottomSheet !== "undefined" && PCrossSellingBottomSheet) === "function" ? _l : Object, typeof (_m = typeof PCrossSellingAddToCartBottomSheet !== "undefined" && PCrossSellingAddToCartBottomSheet) === "function" ? _m : Object])
], PMenuIntegrationContext);
export { PMenuIntegrationContext };
